"use client";
import Link from "@/components/common/DashboardLink";
import Image from "@/components/AppImage";
import { PaylioContext } from "@/context/context";
import { useReceiveFunding } from "@/hooks/useReceiveFunding";
import { getAccountLastFour } from "@/services/receiveFundingApi";
import { useContext, useMemo } from "react";
import { BsLightningChargeFill } from "react-icons/bs";
import support_icon from "/public/images/icon/support-icon.png";

function formatHeaderDate() {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

const ReceiveLandingMain = () => {
  const { activeLefMenu } = useContext(PaylioContext);
  const { data, loading } = useReceiveFunding();
  const bank = data?.bank;

  const last4 = useMemo(() => getAccountLastFour(bank) || "····", [bank]);
  const displayBrand = (bank?.displayBrand || "FlowPay").trim();
  const partnerName = typeof bank?.bankName === "string" ? bank.bankName.trim() : "";
  const partnerBadge = (bank?.partnerBadge || "FDIC Insured").trim();
  const holder =
    typeof bank?.accountName === "string"
      ? bank.accountName.split("—")[0].trim()
      : "";

  return (
    <section
      className={`dashboard-section receive-flowpay receive-landing ${
        activeLefMenu ? "body-collapse" : ""
      }`}>
      <div className="overlay pt-120">
        <div className="container-fruid">
          <div className="main-content">
            <header className="fp-recv-landing__header">
              <div>
                <h1 className="fp-recv-landing__page-title">Receive</h1>
                <p className="fp-recv-landing__date">{formatHeaderDate()}</p>
              </div>
              <div className="fp-recv-landing__support">
                <Image src={support_icon} alt="" />
              </div>
            </header>

            <p className="fp-recv-landing__intro">
              Your linked US virtual bank account. Share these details with clients to receive USD
              — funds are instantly converted and dispatched to your crypto wallet.
            </p>

            <Link href="/receive/step-1" className="fp-recv-landing__card">
              <div className="fp-recv-landing__card-top">
                <div className="fp-recv-landing__card-status">
                  <span className="fp-recv-landing__dot" aria-hidden />
                  <span className="fp-recv-landing__kicker">US virtual bank account</span>
                </div>
                <div className="fp-recv-landing__partner-block">
                  <span className="fp-recv-landing__micro-label">Bank partner</span>
                  {loading ? (
                    <span className="fp-recv-landing__skeleton-line" />
                  ) : (
                    <>
                      <span className="fp-recv-landing__partner-name">
                        {partnerName || "Institution from your API"}
                      </span>
                      <span className="fp-recv-landing__partner-badge">{partnerBadge}</span>
                    </>
                  )}
                </div>
              </div>

              <div className="fp-recv-landing__brand">
                {loading ? <span className="fp-recv-landing__skeleton-brand" /> : displayBrand}
              </div>

              <div className="fp-recv-landing__mask" aria-label="Masked account number">
                <span>····</span>
                <span>····</span>
                <span>····</span>
                <span className="fp-recv-landing__mask-last">{last4}</span>
              </div>

              <div className="fp-recv-landing__card-bottom">
                <div className="fp-recv-landing__holder">
                  <span className="fp-recv-landing__micro-label">Account holder</span>
                  {loading ? (
                    <span className="fp-recv-landing__skeleton-line fp-recv-landing__skeleton-line--short" />
                  ) : (
                    <span className="fp-recv-landing__holder-name">{holder || "—"}</span>
                  )}
                </div>
                <div className="fp-recv-landing__supports">
                  <span className="fp-recv-landing__micro-label">Supports</span>
                  <div className="fp-recv-landing__pills">
                    <span className="fp-recv-landing__pill fp-recv-landing__pill--ach">ACH</span>
                    <span className="fp-recv-landing__pill fp-recv-landing__pill--wire">Wire</span>
                  </div>
                </div>
                <div className="fp-recv-landing__fp-badge" aria-hidden>
                  <BsLightningChargeFill />
                  <span>FP</span>
                </div>
              </div>

              <p className="fp-recv-landing__tap-hint">Tap to view account details</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReceiveLandingMain;
